/**
 * Agent Configure Page.
 *
 * Wraps the SalesAgentContent editor with a header and breadcrumb back to /agents.
 */

import React from 'react';
import { Helmet } from 'react-helmet';
import { useSearchParams } from 'react-router-dom';
import { PageHeader } from '@/components/layout/PageHeader';
import { SalesAgentContent } from '@/pages/platform_views/SalesAgentPage';

const AgentConfigurePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const rawVersionParam = searchParams.get('version');
  const versionNumber = rawVersionParam ? Number.parseInt(rawVersionParam, 10) : null;
  const isViewingVersion = versionNumber !== null && Number.isInteger(versionNumber) && versionNumber > 0;

  return (
    <>
      <Helmet>
        <title>{isViewingVersion ? `Version ${versionNumber}` : 'Agent'} | Hobbes</title>
      </Helmet>

      <div className="flex min-h-0 flex-col">
        <PageHeader
          breadcrumbs={[
            { label: 'Versions', href: '/agents' },
            { label: isViewingVersion ? `Version ${versionNumber}` : 'Agent' },
          ]}
          titleTooltip="Configure how this agent behaves."
        />

        {/* Config Editor */}
        <SalesAgentContent />
      </div>
    </>
  );
};

export default AgentConfigurePage;
